import { Descriptions } from 'admin-web-ui'
import React from 'react'

interface Props {
  metaData: {
    issuer: string
    keyId: string
  }
}

export const DeviceCheckKeyMetaData: React.FC<Props> = ({ metaData }) => (
  <Descriptions bordered column={1}>
    <Descriptions.Item label="Key ID">{metaData.keyId}</Descriptions.Item>
    <Descriptions.Item label="Team ID">{metaData.issuer}</Descriptions.Item>
  </Descriptions>
)
